import { Box } from "@mui/material";
import { Pill, type PillSize, type PillVariant } from "@src/appV2/redesign/system/ui-components";

interface LimitedShiftPillProps {
  size?: PillSize;
  variant?: PillVariant;
  compact?: boolean;
  disabled?: boolean;
}

export function LimitedShiftPill(props: LimitedShiftPillProps) {
  const { size = "small", variant = "outlined", compact = false, disabled = true } = props;

  return (
    <>
      <Pill
        variant={variant}
        size={size}
        label={compact ? undefined : "Limited"}
        iconType="locked-filled"
        backgroundColor={(theme) => theme.palette.background.tertiary}
        color={() =>
          // This was using the tiers palette which is no longer in our theme
          // -> "theme.palette.tiers?.limited.text"
          // Please either switch to another color, or add this one to the theme under a different palette
          // eslint-disable-next-line no-restricted-syntax
          "#82090F"
        }
        iconColor={() =>
          // This was using the tiers palette which is no longer in our theme
          // -> "theme.palette.tiers?.limited.text"
          // Please either switch to another color, or add this one to the theme under a different palette
          // eslint-disable-next-line no-restricted-syntax
          "#82090F"
        }
        outlineColor={() =>
          // This was using the tiers palette which is no longer in our theme
          // -> "theme.palette.tiers?.limited.text"
          // Please either switch to another color, or add this one to the theme under a different palette
          // eslint-disable-next-line no-restricted-syntax
          "#82090F"
        }
        sx={{
          width: "fit-content",
          zIndex: 3,
        }}
      />
      {disabled && (
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 2,
          }}
        />
      )}
    </>
  );
}
